import { ref, computed, watchEffect, onMounted, watch, onBeforeMount, onBeforeUnmount } from 'vue'

import { useEventCenter } from '@haohan/clw-event'
import {
  emitter,
  buildQuery,
  buildTimeRangeWhere,
  exeCustomFun,
  buildApiQueryByEvent,
  transformInvokePayloadToFormDataFromKeys,
  handleApiAfterFun,
  getApiDataPath
} from '@haohan/clw-utils'
import { useProject, useEvent, useApp, useWidget, useGlobalStore } from '@haohan/clw-store'
import { cloneDeep, forEach as ForEach, get, has } from 'lodash-es'
import {
  queryDatasetData,
  getApiMenu,
  invokeApiMenu,
  queryLFMenuItemReq,
  invokeLogicFlow
} from '@haohan/clw-api'
import { useCompPermissionHook } from '../usePermissonHook'
import { useStyle } from '../useStyle'
import { usePanel } from '../usePanel'
import {
  hasProp,
  transFormQueryData2SourceData,
  handleApiResponseData,
  transformLogicFlowParams,
  transSelectOption
} from '@haohan/clw-utils'
import { useI18n } from 'vue-i18n'
export const useCommonForGeneral = (
  props: any,
  customAttrs: any = {
    getEventValueCanUseObj: () => {
      return {}
    },
    listenerEventOperation: (...args: any) => {}
  }
) => {
  const { getEventValueCanUseObj, listenerEventOperation } = customAttrs
  // 使用store
  const globalStore = useGlobalStore()
  const project = useProject()
  const event = useEvent()
  const app = useApp()
  const widget = useWidget()
  const {
    sendEvent,
    getEventValuesByOperation,
    sendEventByTriggerType,
    registerComponent,
    sendEventByEvent,
    setReceiveEventBindValue,
    getLasterUpdateValue,
    readyStatus
  } = useEventCenter()
  const { t } = useI18n()

  const isReady = readyStatus(props.item)

  const currentProject = computed(() => {
    return project.currentProject
  })
  const commonParameters = computed(() => {
    return event.commonParameters
  })
  const selectedDateRange = computed(() => {
    return app.selectedDateRange
  })
  const pages = computed(() => project.pages)
  const currentPage = computed(() => project.currentPage)
  const receiveEvents = computed(() => event.receiveEvents)
  const editModel = computed(() => globalStore.edieModel)
  const isPlatform = computed(() => globalStore.isPlatform)
  const lastUpdateTime = computed(() => globalStore.lastUpdateTime)
  const currentFormStep = computed(() => {
    return project.currentFormStep
  })

  const promptlyEventValues = ref([])
  const filterRange = ref([])
  const filterWhere = ref<any>([])
  const bindComParamValue = ref('')

  // 将组件属性数组转换成对象
  // const attributes = computed(() => transformArray2Object(props.item.attributes))
  const prop = computed(() => props.item.prop)
  const formProp = computed(() => props.item.formProp as any)
  const styleProp = computed(() => props.item.styleProp)
  const dataProp = computed(() => props.item.dataProp) as any
  const publicParameters = computed(() => {
    return event.publicParameters
  })
  // 组件需要的额外信息
  const widgetQueryInfo = computed(() => {
    return {
      treasuryCtrl: prop.value && has(prop.value, 'treasuryCtrl') ? prop.value.treasuryCtrl : false
    }
  })

  // 当监听得监护中，有执行方法为 onlyReceiveEvent 时，则认为需要等到主动执行reloadByEvent时
  // 才会去出发数据得请求
  const canLoadData = ref<boolean>(false)
  onBeforeMount(() => {
    canLoadData.value =
      props.item.events?.findIndex(
        (e: WidgetEvent) => e.eventType === 'receive' && e.performOperation === 'onlyReceiveEvent'
      ) === -1
  })
  // 获取属性中全部的样式属性
  const { box } = useStyle(styleProp)

  const tableId = computed(() => dataProp.value?.tableId)
  // 组件数据的类型，可能未定义
  const dataSourceType = computed<any>(() => props.item.dataSourceType)
  // 主题
  const pageTheme = computed(() => project.currentPage.variables?.theme)
  // 组件的查询时间
  const queryRangs = computed(() => {
    const rangs = buildTimeRangeWhere(app.selectedDateRange, filterRange.value, {
      queryTimeType: dataProp.value?.queryTimeType,
      startInterval: dataProp.value?.startInterval,
      endtInterval: dataProp.value?.endtInterval,
      customTimeType: dataProp.value?.customTimeType
    })
    return rangs
  })
  const pageStyle = computed(() => {
    const bgColor = project?.currentPage?.variables?.bgColor
    return bgColor
  })
  function clickWidget() {
    widget.changeSelectWidget(props.item)
  }
  // 根据全局变量设置默认值
  function setComParamValue() {
    if (
      prop.value?.comParam &&
      prop.value.comParam.trim() !== '' &&
      commonParameters.value[prop.value.comParam]
    ) {
      bindComParamValue.value = commonParameters.value[prop.value.comParam].value!
    }
    if (
      formProp.value?.comParam &&
      formProp.value.comParam.trim() !== '' &&
      commonParameters.value[formProp.value.comParam]
    ) {
      bindComParamValue.value = commonParameters.value[formProp.value.comParam].value!
    }
  }
  function setDateRange(timerange: string[]) {
    return app.setDateRange(timerange)
  }
  function updateCommonParameterValue(kv: any) {
    return event.updateCommonParameterValue(kv)
  }
  const currentCompKey = computed(() => props.item.key)
  const { activePanelIx, mappingTabsKey, activePanelKey } = usePanel()

  const { pmCtrl, pmShow, pmPermission } = useCompPermissionHook(currentCompKey.value)
  const needPermission = computed(() => !isPlatform.value && pmCtrl.value)
  const dealCompShow = computed(() => isPlatform.value || !pmCtrl.value || pmShow.value)
  const dealCompCtrl = computed(
    () => isPlatform.value || !pmCtrl.value || pmPermission.value.includes('可操作')
  )
  //
  const data = ref<any>({
    content: [],
    page: 1,
    size: 10,
    total: 0,
    totalPages: 0
  })

  const queryPage = ref(1)
  const loading = ref(false)
  const stopLodaData = ref()
  const sourceData = ref([])
  const loadDataRepeatTimer = ref()
  const apiResponseInfo = ref()

  const handleData = (data: any) => {
    // TODO: 子组件可覆盖刚方法进行自定义数据处理
    if (props.item.customDataHandle) {
      return exeCustomFun(props.item.customDataHandle, data)
    }
    return data
  }
  const handleCustomApiData = () => {
    const initData = (_d = []) => {
      const _data = {
        content: _d,
        page: 1,
        size: 10,
        total: 0,
        totalPages: 0
      }
      data.value = _data
    }
    // 兼容之前定义在API接口中的 dataPath
    const dataPath = getApiDataPath(dataProp.value?.apiDataPath, apiResponseInfo.value.api)
    if (dataPath || dataPath === '') {
      try {
        // 根据自定义的 dataPath 去取数据
        // const content = eval(`res.${dataPath}`)
        const content =
          dataPath === '' ? apiResponseInfo.value.data : get(apiResponseInfo.value.data, dataPath)
        if (content) {
          const dData = content
          // 执行自定义函数, 转换每行内容
          handleData(dData)
          const _data = {
            content: dData,
            total: dData.length,
            totalPages: 1,
            page: 1,
            size: dData.length
          }
          data.value = _data
        } else {
          initData()
        }
      } catch (error) {
        initData()
      }
    } else if (['HHText'].includes(props.item.type)) {
      // 有一些组件不需要指定层级，直接使用具体的属性
      initData(apiResponseInfo.value.data)
    } else {
      initData()
    }
  }
  const loadData = async () => {
    if (customAttrs.loadData) {
      customAttrs.loadData()
      return
    }
    // 服务器数据
    if (dataSourceType.value === 'TableSource') {
      if (!tableId.value || !canLoadData.value || dataSourceType.value !== 'TableSource') {
        return false
      }
      loading.value = true
      // 避免无法正确获得store中的时间值
      const appStore = useApp()
      const queryParam: any = buildQuery(
        buildTimeRangeWhere(appStore.selectedDateRange, filterRange.value, {
          queryTimeType: dataProp.value?.queryTimeType,
          startInterval: dataProp.value?.startInterval,
          endtInterval: dataProp.value?.endtInterval,
          customTimeType: dataProp.value?.customTimeType
        }),
        getEventValuesByOperation(props.item.events || []),
        filterWhere.value
      )
      queryParam.page = queryPage.value
      queryParam.size = dataProp.value?.pageSize ? +dataProp.value?.pageSize : 10
      queryDatasetData(currentProject.value.id, tableId.value, queryParam, widgetQueryInfo.value)
        .then((resp: any) => {
          const _d = transFormQueryData2SourceData(resp.data)
          sourceData.value = _d
          data.value.content = handleData(_d.content)
        })
        .finally(() => {
          loading.value = false
        })

      // 自定义 API
    } else if (dataSourceType.value === 'CustomApi') {
      if (!tableId.value) {
        Object.assign(data.value, {
          content: [],
          page: 1,
          size: 10,
          total: 0,
          totalPages: 0,
          ceshi: 99
        })
        return false
      }
      const { data: _data } = await getApiMenu(currentProject.value.id, tableId.value)
      // 拼装交互过滤参数
      const eventQueryParam = buildApiQueryByEvent(
        getEventValuesByOperation(props.item.events || [])
      )
      // eval 用到这个 res
      const res = await invokeApiMenu(
        currentProject.value.id,
        tableId.value,
        transformInvokePayloadToFormDataFromKeys(_data?.keysDefine.def, eventQueryParam),
        _data.headers,
        eventQueryParam,
        widgetQueryInfo.value
      )
      // 占位, 不然生产环境 res 会被删掉
      const resTemp = cloneDeep(res)
      // 记录下接口返回数据，以便层级变化时，更改数据
      apiResponseInfo.value = {
        api: _data,
        data: handleApiResponseData(handleApiAfterFun(_data.postPosition, res))
      }
      handleCustomApiData()

      // 本地数据
    } else if (dataSourceType.value === 'LogicFlowSource') {
      if (!tableId.value) {
        Object.assign(data.value, {
          content: [],
          page: 1,
          size: 10,
          total: 0,
          totalPages: 0
        })
        return false
      }
      const projectStore = useProject()
      const projectId = projectStore.currentProject?.id
      // 获得逻辑流详细信息
      const { data: _data } = await queryLFMenuItemReq(projectId, tableId.value)
      // 获得交互查询参数等信息
      const eventQueryParam = buildApiQueryByEvent(
        getEventValuesByOperation(props.item.events || [])
      )
      // 处理逻辑流数据
      const res = await invokeLogicFlow(
        projectId,
        tableId.value,
        transformLogicFlowParams(_data.parameters, eventQueryParam),
        widgetQueryInfo.value
      )
      apiResponseInfo.value = {
        api: data,
        data: handleApiResponseData(res)
      }
      handleCustomApiData()

      // 本地数据
    } else if (dataSourceType.value === 'LocalData') {
      data.value.content = dataProp.value?.defaultData
    }
  }
  // 主要为下拉等组件使用
  const list = computed(() => {
    if (dataSourceType.value === 'LocalData') {
      return dataProp.value?.defaultData
    } else if (
      dataSourceType.value === 'TableSource' ||
      ((dataSourceType.value === 'CustomApi' || dataSourceType.value === 'LogicFlowSource') &&
        dataProp.value?.apiDataPath !== '')
    ) {
      const xAxisField = dataProp.value?.xAxisField
      const labelCol = dataProp.value?.labelCol || dataProp.value?.xAxisField
      if (xAxisField) {
        if (data.value.content instanceof Array) {
          return data.value.content?.map((el: any) => {
            return {
              label: el[labelCol],
              value: el[xAxisField],
              children: el.children
            }
          })
        }
        return []
      }
    } else if (dataSourceType.value === 'CustomApi' || dataSourceType.value === 'LogicFlowSource') {
      if (!has(dataProp.value, 'apiDataPath')) {
        // 当数据源为自定义API时，直接取对应属性的值
        return get(data.value.content, dataProp.value?.xAxisField)
      }
      const _data = data.value.content
      const xAxisField = dataProp.value?.xAxisField
      const labelCol = dataProp.value?.labelCol || dataProp.value?.xAxisField
      if (xAxisField) {
        if (_data instanceof Array) {
          return transSelectOption(_data, xAxisField, labelCol)
        }
        return []
      }
    }
    return []
  })
  const buildOption = () => {
    setComParamValue()
  }
  watch(
    () => props.item,
    () => {
      if (editModel.value) {
        buildOption()
      }
    },
    { deep: true }
  )
  const calcLevel = (item: any): number => {
    if (!Array.isArray(item) || item.length === 0) return 0

    function traverse(node: { children: any[] }, depth = 1) {
      if (!node.children || node.children.length === 0) {
        return depth
      }

      let maxDepth = depth
      for (const child of node.children) {
        const childDepth = traverse(child, depth + 1)
        maxDepth = Math.max(maxDepth, childDepth)
      }

      return maxDepth
    }

    // 遍历顶层的每一个根节点，取最大深度
    let maxLevel = 0
    for (const root of item) {
      maxLevel = Math.max(maxLevel, traverse(root))
    }

    return maxLevel
  }
  watch(
    () => list.value,
    (nv) => {
      if (props.item.type === 'HHSelectWidget') {
        // const levels = list.value.map((el) => calcLevel(el))
        // console.log(levels)
        widget.upCascaderLevel(calcLevel(nv))
      }
    },
    { deep: true }
  )
  watch(
    () => selectedDateRange.value,
    () => {
      if (!editModel.value) {
        loadData()
      }
    },
    { deep: true }
  )
  watch(
    () => dataProp.value?.apiDataPath,
    () => {
      handleCustomApiData()
    },
    { deep: true }
  )

  const stopEditModelWatch = () => {
    if (editModel.value && stopLodaData.value) {
      stopLodaData.value()
    }
  }
  onBeforeMount(() => {
    if (stopLodaData.value) {
      stopLodaData.value()
    }
    // 注册组件
    registerComponent(props.item, listenerEventOperation, getEventValueCanUseObj)
  })
  onBeforeMount(() => {
    buildOption()
  })
  onMounted(() => {
    if (isReady.value) {
      loadData()
    }
    if (editModel.value) {
      emitter.on('change-dit-page', stopEditModelWatch)
    }
  })
  onBeforeUnmount(() => {
    if (editModel.value) {
      emitter.off('change-dit-page')
    }
  })

  const reload = () => {
    loadData()
  }

  const exeReloadByEvent = () => {
    if (customAttrs?.exeReloadByEvent) {
      customAttrs.exeReloadByEvent()
    } else {
      canLoadData.value = true
      reload()
    }
  }
  const GLOBAL_CONSTANT = {
    LOAD_DATA_REPEAT_DELAY: 300 // 重复执行加载事件延迟数
  }
  const reloadByEvent = () => {
    if (loadDataRepeatTimer.value) {
      clearTimeout(loadDataRepeatTimer.value)
    }
    loadDataRepeatTimer.value = setTimeout(exeReloadByEvent, GLOBAL_CONSTANT.LOAD_DATA_REPEAT_DELAY)
  }

  const onlyReceiveEvent = () => {
    // 仅接收交互值，不做任何操作
  }

  const dataInfo = computed(() => {
    return {
      dataSourceType: dataSourceType.value,
      ...dataProp.value
    }
  })

  watch(
    () => dataInfo.value,
    () => {
      if (editModel.value) {
        loadData()
      }
    },
    { deep: true }
  )

  return {
    item: props.item,
    promptlyEventValues,
    filterRange,
    filterWhere,
    bindComParamValue,
    prop,
    formProp,
    styleProp,
    dataProp,
    box,
    currentProject,
    commonParameters,
    selectedDateRange,
    tableId,
    dataSourceType,
    pages,
    currentPage,
    receiveEvents,
    currentFormStep,
    clickWidget,
    setComParamValue,
    setDateRange,
    updateCommonParameterValue,
    pageTheme,
    editModel,
    widget,
    queryRangs,
    canLoadData,
    hasProp,
    pageStyle,
    activePanelIx,
    mappingTabsKey,
    currentCompKey,
    activePanelKey,
    lastUpdateTime,
    dealCompShow,
    dealCompCtrl,
    pmPermission,
    needPermission,
    widgetQueryInfo,
    data,
    queryPage,
    loading,
    stopLodaData,
    sourceData,
    loadDataRepeatTimer,
    apiResponseInfo,
    list,
    loadData,
    reload,
    reloadByEvent,
    onlyReceiveEvent,
    sendEvent,
    sendEventByTriggerType,
    registerComponent,
    setReceiveEventBindValue,
    getLasterUpdateValue,
    getEventValuesByOperation,
    handleData,
    sendEventByEvent,
    publicParameters,
    t
  }
}
